var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.$.board_container, _vm.$.skeleton] }, [
    _c(
      "div",
      { class: _vm.$.columns_container },
      _vm._l(_vm.columns, function (col) {
        return _c("column-skeleton", {
          key: "column_skeleton_" + col.id,
          attrs: { data: col },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }